<template>
	<div class="pre-check-in">
		<!-- 预入住登记 -->
		<section class="register">
			<div class="one">
				<section class="top">
					<h3>预约登记</h3>
					<el-button @click="modifyClick" class="detail" v-if="!isShowPreCheckIn">修 改</el-button>
					<!-- <img src="../../assets/icon/edit.png" alt="" class="modifyImg" @click="modifyClick"> -->
					<div style="margin-left: 30px;">
						<div class="description" v-if="isShowPreCheckIn">
							<p style="width: 80%;">
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年人才公寓项目即将迎接你们的入住，在新的一年里为了维护广大业的切身利益,请各位业主在百忙中尽快完成预入住的登记。
							</p>

						</div>

						<div class="isShowPreCheckIn" v-if="isShowPreCheckIn">
							<p @click="preCheckInClick" class="preBtn" style="cursor: pointer;">预入住登记</p>
						</div>

					</div>

					<section v-if="!isShowPreCheckIn">
						<div class="preCheckIn">
							<ul>
								<template v-if="formData.subscribePlanFlag == 1">
									<li>
										<img src="../../assets/icon/peopleNumber.png" alt="">
										<p>已预订人数</p>
										<p><span class="number">{{ formData.personNum }}</span>&nbsp;人</p>
									</li>
									<li>
										<img src="../../assets/icon/roomNumber.png" alt="">
										<p>已预订房间数</p>
										<p><span class="number">{{ formData.roomNum }}</span>&nbsp;间</p>
									</li>
								</template>
								<template v-else>
									<li>
										<p>暂无入住</p>
										<p><span class="number">{{ formData.subscribePlanYear }}</span></p>
									</li>
								</template>
							</ul>
						</div>
					</section>

				</section>
			</div>
			<div class="zero">
				<h3>人才登记</h3>
				<el-button @click="toApplyCheckIn" class="detail">查看详情</el-button>
				<div>
					<div>
						<vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
							:logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
					</div>
					<div style="margin-left: 20px;">
						<p>请将二维码分享给人才</p>
						<p>通过扫码进行自主登记</p>
					</div>
				</div>
			</div>
			<div class="two">
				<el-tabs v-model="activeNotice" @tab-click="handleNotice">
					<el-tab-pane label="公告" name="first"></el-tab-pane>
					<el-tab-pane label="通知" name="second"></el-tab-pane>
					<div>
						<p v-for="(item, index) in noticeAndMessageNum" class="message"><span
								class="circle"></span>{{ item.title }}
							<span
								style="font-size: small;position: absolute;right: 5px;">{{ item.days == 0 ? '今天发送' : item.days + '天前发送' }}</span>
						</p>
					</div>
				</el-tabs>
				<p @click='$router.push("/index/console/announceAndNotice")' class="more">更多</p>
			</div>

		</section>
		<section class="bottom">
			<div class="three">
				<h3>客房详情</h3>
				<div id="three"></div>
				<el-button @click="toCustomerRoom" class="detail">查看详情</el-button>
				<!-- <img src="../../assets/icon/detail.png" alt="" class="detail" @click="toCustomerRoom"> -->
			</div>
			<div class="five">
				<h3>人才详情</h3>
				<div id="five"></div>
				<!-- <img src="../../assets/icon/detail.png" alt="" class="detail" @click="toTalentDetail"> -->
				<el-button @click="toTalentDetail" class="detail">查看详情</el-button>
			</div>

			<!-- <div class="four" @mousemove="buildShow = true" @mouseout="buildShow = false"> -->
			<div class="four">
				<h3>商铺时段能耗</h3>
				<el-button class="detail" @click="toEnerygyData">查看详情</el-button>
				<!-- <p class="build" v-show="buildShow">正在建设中</p> -->
				<div id="four">
				</div>
			</div>

		</section>

		<!-- 增加预入住登记 -->
		<el-dialog title="预入住登记" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<div style="margin: 20px 10px;">
				<el-radio v-model="subscribePlanFlag" :label="2">暂无入住</el-radio>
				<el-radio v-model="subscribePlanFlag" :label="1">预入住登记</el-radio>
			</div>
			<el-form :model="checkInFormData" label-width="100px" :rules="rules" ref="formData">
				<template v-if="subscribePlanFlag == 1">
					<el-form-item label="预约房间数" prop="roomNum">
						<el-input v-model.number="checkInFormData.roomNum" type="number" placeholder="请输入数量"
							style="width: 80%;" min="0"></el-input>
					</el-form-item>
					<div style="width: 100%;text-align: right;margin-bottom: 20px;font-weight: 800;">共{{ allRoomNum }}房间数
					</div>
					<el-form-item label="预入住人数" prop="personNum">
						<el-input v-model.number="checkInFormData.personNum" type="number" placeholder="请输入数量"
							style="width: 80%;" min="0" @input="personNumInput"></el-input>
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item label="入住计划" prop="subscribePlanYear">
						<el-select v-model="checkInFormData.subscribePlanYear" clearable="">
							<el-option value="半年以内" label="半年以内"></el-option>
							<el-option value="半年以上一年以内" label="半年以上一年以内"></el-option>
							<el-option value="一年以上" label="一年以上"></el-option>
						</el-select>
					</el-form-item>
				</template>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button style="background-color:#B5AC8B;color: white;" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>



		<!-- <PersonalInfor :personInforVisible="personInforVisible" @changeVisible="changeVisible"></PersonalInfor> -->


		<!-- 		<el-dialog title="" :visible.sync="propertyFeeVisible" width="30%" :close-on-click-modal="false"
		  :modal-append-to-body="false" :show-close="false">
			<div class="tenement">
				<p style="font-size: 17px;">尊敬的各位业主：</p>
				<p style="margin-left: 20px;">您好！</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年人才公寓项目即将迎接你们的入住，在新的一年里为了维护广大业主的切身利益，保障公寓公司的服务品质，请各位业主在百忙中尽快预交2021年相关公寓服务费，我们不甚感激。</p>
				<p></p>
				<p style="margin-top: 30px;">收款信息如下：</p>
				<p>单位名称：南京金陵汇德公寓管理有限公司</p>
				<p>银行开户行：上海银行南京新街口支行</p>
				<p>账号：03003940836</p>
				<p>电话：84711888</p>
				<p>地址：南京市汉中路2号</p>
				<p></p>
				<p style="text-align: right;margin-top: 35px;">南京金陵汇德公寓管理有限公司</p>
				<p style="text-align: right;">2020年元月20日</p>
				<p>
					<el-checkbox v-model="tenementChecked">我单位已知晓本次通知</el-checkbox>
				</p>
				<p>
					<span class="download" @click="downloadFile(1)">物业收费.doc</span>
				</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button style="background-color:#B5AC8B;color: white;" :disabled="!tenementChecked" @click="confirmTenement(2)">已阅读</el-button>
			</span>
		</el-dialog> -->

		<!-- 		<el-dialog title="" :visible.sync="fireSafetyVisible" width="45%" :close-on-click-modal="false"
		  :modal-append-to-body="false" :show-close="false">
			<div class="fireSafety">
				<p style="text-align: center;font-size: 20px;font-weight: bold;padding-bottom: 40px;">消防安全责任书</p>
				<p>为了切实做好江苏省人才公寓项目的消防安全工作，全面落实消防安全责任制，明确职责，强化责任，预防各类火灾事故的发生，保护广大职工生命财产和企业的安全，根据《中华人民共和国消防法》、《机关、团体、企业、事业单位消防安全管理规定》和金陵饭店集团公司的有关规定，特制定此责任书。</p>
				<p>一、按照“安全第一，预防为主”和“预防为主，防消结合”的方针，认真贯彻执行安全生产、消防安全工作的各项法律、法规和公司的各项规章制度。</p>
				<p>二、各业主单位要自觉接受安全部门的管理，落实安全防火工作，经常对入住员工开展消防知识、消防技能、消防器材使用的宣传教育，组织灭火和应急疏散预案的实施和演练，不断提高员工预防和扑救火灾的能力，保证入住人员人员做到“三懂三会四个能力”，即：三懂：懂基本消防常识、懂消防设施器材使用方法、懂逃生自救技能，三会：会查改火灾隐患、会扑救初起火灾、会组织人员疏散。四个能力：1．提高检查消除火灾隐患能力，2．提高组织扑救初起火灾能力，3．提高组织人员疏散逃生能力，4．提高消防宣传教育培训能力。</p>
				<p>三、按照“谁管理、谁负责”的原则进行消防管理范围及责任划分，做到纵向到底、横向到边，使江苏省人才公寓项目的消防工作真正落到实处，具体到个人，同时各入住人员要做到以下几点：</p>
				<p>1、每天上班前应检查房间安全，做到断水、断电、关窗锁门。</p>
				<p>2、用电设备必须保持正常运转，严禁超负荷运行，严禁带病作业。</p>
				<p>3、公寓房内禁止私接电源，严禁存放易燃、易爆化学危险品，严禁使用电炉、热得快、酒精炉等。</p>
				<p>4、安装和修理用电设备时，应由专业人员进行操作并认真检验。室内电路不准变动，因工作必须变动时，要经安全部及工程部批准。</p>
				<p>5、如入住人员需改变公寓内房屋结构或装修风格，需向物业部门报备审核。</p>
				<p>6、未经物业部门允许，不准私拉线路，必需的临时线要随用随拆，以防火灾。</p>
				<p>7、严禁在床上或沙发上吸烟。</p>
				<p>四、严格本辖区的消防设施的制度管理：</p>
				<p>1、消防器材要安置在指定地点，不准随意移动或作其他使用，不准在消防器材附近堆放任何物品，同时保持消防器材清洁完好、有效。</p>
				<p>2、维护好本公寓内的消防设施。如（灭火器、箱、消火栓、应急疏散指示灯、应急疏散安全出口指示牌、疏散安全出口标志、喷淋、烟（温）感器）等。</p>
				<p>3、疏散通道、安全出口、消防器材应严格按照国家消防法规的有关规定严禁堆放杂物及堵塞通道。安全出入指示标识严禁遮挡，确保安全通道的畅通。</p>
				<p>4、各入住人员应人人熟练掌握“三会”：会疏散、会报警、会使用灭火器，并将消防安全问题消除在萌芽状态。</p>
				<p>5、公寓内部所有办公家具、打印机、复印件等办公设备的摆放不得遮挡灭火器、配电箱，并距消防喷淋头、烟感器0.5米以上。上述消防设施未经许可不得更改且应保持整洁、有序和安全。</p>
				<p>6、遵守安全防火规定，严禁将易燃、易爆、剧毒等危险品带入公寓房内。</p>
				<div style="margin:45px 10px 10px ;">
					<el-checkbox v-model="fireChecked">我单位已知晓本次通知</el-checkbox>
				</div>
				<p>
					<span class="download" @click="downloadFile(2)">消防安全责任书.doc</span>
				</p>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button style="background-color:#B5AC8B;color: white;" @click="confirmTenement(1)" :disabled="!fireChecked">已阅读</el-button>
			</span>
		</el-dialog> -->

	</div>
</template>

<script>
import vueQr from 'vue-qr'
import {
	phoneRules,
	checkIdentitytionId
} from '../apartment/verify.js'
import publicExport from '../../assets/js/publicExport.js'
import downloadFile from '../../assets/js/downloadFile.js'
import PersonalInfor from './component/PersonInfor.vue';


export default {
	data() {
		let pattern = /^[1-9][0-9]*$/;
		let validateRoomNum = (rule, value, callback) => {
			if (value > this.allRoomNum) {
				callback(new Error("预约房间数不可以大于可用房总数"));
			} else if (!pattern.test(value)) {
				callback(new Error("预约房间数必须为整数"));
			} else {
				callback();
			}
		}

		let validatePersonNum = (rule, value, callback) => {
			// if (value > this.formData.roomNum * 2 + 5) {
			// 	callback(new Error("预约入住人数建议不要过多"));
			// } else 
			if (!value) {
				console.log("---------");
				this.$message.close();
				callback(new Error("请输入房间数"));
			} else if (!pattern.test(value)) {
				callback(new Error("预约入住人数必须为整数"));
			} else {
				callback();
			}
		}
		return {
			dialogVisible: false,
			isShowPreCheckIn: null, //是否预入住登记
			allRoomNum: null,
			formData: {
				// subscribePlanFlag: 1,
				personNum: null,
				roomNum: null,
				subscribePlanYear: "半年以内",
			},
			flag: null,
			subscribePlanFlag: 1,
			formData2: {
				personNum: null,
				roomNum: null,
				subscribePlanYear: "半年以内",
			},
			checkInFormData: {},
			imageUrl: "",
			// propertyFeeVisible: false, //物业费显隐
			//fireSafetyVisible: false, //消防安全显隐
			tenementChecked: false, //单位checkbox
			fireChecked: false, //消防checkbox

			personInforVisible: false, //个人信息显影

			activeNotice: 'first', //选中的信息

			rules: {
				roomNum: [{
					required: true,
					message: '预约房间数不能为空',
					trigger: ["blur", "change"]
				}, {
					validator: validateRoomNum,
					trigger: ["blur", "change"]
				}],
				personNum: [{
					required: true,
					message: '预入住人数不能为空',
					trigger: ["blur", "change"]
				}, , {
					validator: validatePersonNum,
					trigger: ["blur", "change"]
				}],
			},

			sum: 0, //所有客房数量
			free: 0, //空闲中数量
			checkedIn: 0, //已入住数量
			toBeCheckIn: 0, //待入住数量
			maintain: 0, //维护中数量
			noticeAndMessageNum: [],
			buildShow: false,
			downloadData: {
				//正式//www.itc-mall.com.cn
				//测试//http://101.132.184.43
				url: this.$global.webUrl + '/mobileForm?ownerId=' + sessionStorage.getItem("createId"),
				//url: 'https://rcweb.yjhj.city/mobileForm?ownerId=' + sessionStorage.getItem("createId"), //需要转化成二维码的网址
				icon: require("../../assets/icon/logo.png") //二维码中间的图片,可以不设置
			},

		}
	},
	components: {
		PersonalInfor,
		vueQr,
	},

	mounted() {
		this.getAll();
		this.isJudgePopup();
		this.getPieEcharts();
		this.getLineEcharts();
		this.getBarEchars();
		this.getNoticeAndMessage();
	},
	methods: {
		getAll() {
			// 
			this.$http.get("/api/ownerManage/getOwnerSubscribe").then(res => {
				console.log(res.data)
				if (res.data.code == -1) {
					this.isShowPreCheckIn = true;
					return;
				}
				this.isShowPreCheckIn = false;
				this.formData = res.data.data;
			})

			// 所有房间数
			this.$http.get("/api/ownerManage/getAllRoomNum").then(res => {
				this.allRoomNum = res.data.data;
			})
		},

		// 
		getNoticeAndMessage() {
			let url;
			if (this.activeNotice == "second") {
				url = "/api/message/queryReceiverMessage";
			} else {
				url = "/api/notice/app/queryReceiverNotice";
			}

			this.$http.post(url, {
				currentPage: 1,
				pageSize: 3,
			}).then(res => {
				if (res.data.code == 0) {
					if (res.data.data) {
						this.noticeAndMessageNum = res.data.data.items;
					} else {
						this.noticeAndMessageNum = []
					}
				}
			})
		},


		// 是否弹出物业消费框
		isJudgePopup() {
			this.$http.get("/api/ownerManage/judgePopup").then(res => {
				this.propertyFeeVisible = res.data.data;
				// this.propertyFeeVisible = true;
			})
		},

		// 饼图
		getPieEcharts() {
			let myChart = this.echarts.init(document.getElementById('three'));

			this.$http.get("/api/roomManage/countRoom").then(res => {
				console.log("客房数", res);
				this.sum = res.data.data.sum;
				this.free = res.data.data.free;
				this.maintain = res.data.data.maintain;
				this.toBeCheckIn = res.data.data.toBeCheckIn;
				this.checkedIn = res.data.data.checkedIn;

				let data = [{
					value: this.free,
					name: "空闲中"
				},
				{
					value: this.maintain,
					name: "维护中",
				},
				{
					value: this.toBeCheckIn,
					name: "待入住"
				},
				{
					value: this.checkedIn,
					name: "已入住"
				}
				];
				let option = {

					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b} : {c}"
					},
					legend: {
						x: 'center',
						y: 'bottom',
						data: ['待入住', '空闲中', '已入住', '维护中']
					},
					series: [{
						name: '客房信息',
						type: 'pie',
						radius: ['40%', '70%'],
						data: data,
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold'
							}
						},

						itemStyle: {
							normal: {
								label: {
									show: true,
									formatter: '{b} : {c} '
								},
							},
						}
					}]
				}
				myChart.setOption(option)

			})
		},

		// 折线图
		getLineEcharts() {
			let myChart = this.echarts.init(document.getElementById('four'));
			// this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {

			// })
			let option;
			// option = {
			// 	title: {
			// 		text: '费用信息',
			// 		x: 'center',
			// 	},
			// 	xAxis: {
			// 		type: 'category',
			// 		data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
			// 	},
			// 	yAxis: {
			// 		type: 'value'
			// 	},
			// 	series: [{
			// 		data: [150, 230, 224, 218, 135, 147, 260],
			// 		type: 'line'
			// 	}]
			// };
			// myChart.setOption(option);
			this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then(res => {
                if (res.data.code == 0) {
                    let xArr = []
                    let yArr = [];
                    res.data.data.forEach(element => {
                        xArr.push(element.readingTime)
                        yArr.push(element.positiveElec)
                    });
                    option = {
                        backgroundColor: "",
                        tooltip: {
                            trigger: "axis"
                        },
                        grid: {
                            top: "30",
                            left: "3%",
                            right: "4%",
                            bottom: "3%",
                            containLabel: true
                        },
                        xAxis: {
                            type: "category",
                            axisTick: {
                                show: false //轴线刻度
                            },
                            boundaryGap: false,
                            data: xArr,
                            axisLabel: {
                                // color: "#ffffff",
                                interval: 0,
                            },
                            axisLine: {
                                lineStyle: {
                                    // color: "#ffffff" //x轴颜色
                                }
                            }
                        },
                        color: ["#277CD5"],
                        yAxis: {
                            type: "value",
                            axisTick: {
                                show: false //轴线刻度
                            },
                            axisLabel: {
                                // color: "#ffffff",
                                formatter: '{value}kW·h'
                            },
                            axisLine: {
                                lineStyle: {
                                    // color: "#ffffff" //Y轴颜色
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#505687"
                                }
                            }
                        },
                        series: [{
                            // name: "Highest",
                            data: yArr,
                            type: "line",
                            symbolSize: 8,
                            // areaStyle: {
                            //     color: this.echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                            //         offset: 0.1,
                            //         color: "#212a61"
                            //     },
                            //     {
                            //         offset: 1,
                            //         color: "#277CD5"
                            //     }
                            //     ])
                            // },
                            smooth: true,
                            // markPoint: {
                            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
                            // },
                            // label: {  //显示值
                            //     show: true,
                            //     position: 'top'
                            //   },
                        }]
                    };
					myChart.setOption(option);
                    // this.$echarts.init(this.$refs.rightEcharts2, "dark").setOption(option);
                }
            })
		},

		// 柱形图
		getBarEchars() {
			let myChart = this.echarts.init(document.getElementById('five'));
			console.log(myChart);
			this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
				let data = [{
					value: res.data.data.undergraduate,
					name: "本科"
				},
				{
					value: res.data.data.master,
					name: "硕士",
				},
				{
					value: res.data.data.doctor,
					name: "博士"
				},
				// {
				// 	value: res.data.data.expert,
				// 	name: "其他"
				// },
				{
					value: res.data.data.returnees,
					name: "其他"
				}
				];
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b} : {c}"
					},
					legend: {
						x: 'center',
						y: 'bottom',
						data: ['本科', '硕士', '博士', '其他']
					},
					series: [{
						name: '人才信息',
						type: 'pie',
						radius: '50%',
						data: data,
						avoidLabelOverlap: true, //图饼标签false重复
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						itemStyle: {
							normal: {
								label: {
									show: true,
									formatter: '{b} : {c} '
								},
								labelLine: {
									show: true
								}
							},
						}
					}]
				}
				myChart.setOption(option);
			})
		},


		// 预入住登记
		preCheckInClick() {
			this.flag = true;
			this.formData = {
				...this.formData2
			}
			this.perfectInfor();

		},
		// 判断是否已完善个人信息
		perfectInfor() {
			this.$http.get("/api/ownerManage/perfectInformation").then(res => {
				console.log(res);
				if (res.data.data) {
					this.dialogVisible = true;
				} else {
					this.personInforVisible = true;

					// this.$confirm('请点击右上方完善个人信息', '提示', {
					// 	confirmButtonText: '确定',
					// 	cancelButtonText: '取消',
					// 	type: 'warning'
					// })
				}


			})
		},

		// 子组件向父组件传值personInforVisible
		changeVisible(e) {
			this.personInforVisible = e.personInforVisible;
		},

		// 修改
		modifyClick() {
			this.flag = false;
			this.dialogVisible = true;
			this.checkInFormData = {
				...this.formData
			};
		},
		// 取消
		cancelClick() {
			if (this.isShowPreCheckIn) {
				this.checkInFormData = {
					...this.formData
				};
			}
			console.log(this.checkInFormData);
			console.log(this.$refs.formData);
			this.$refs.formData.clearValidate();
			this.dialogVisible = false;
		},
		//
		handleClose() {
			if (this.isShowPreCheckIn) {
				this.checkInFormData = {
					...this.formData
				};
			}
			this.$refs.formData.clearValidate();
			this.dialogVisible = false;
		},

		// 确定
		confirmClick() {
			console.log(this.checkInFormData);
			this.checkInFormData.subscribePlanFlag = this.subscribePlanFlag;
			this.$refs.formData.validate((valid) => {
				if (!valid) {

				} else {
					if (this.flag) {
						this.$http.post("/api/ownerManage/addOwnerSubscribe", {
							...this.checkInFormData
						}).then(res => {
							this.getAll();
							this.dialogVisible = false;
						})
					} else {
						this.$http.post("/api/ownerManage/modifyOwnerSubscribe", {
							...this.checkInFormData
						}).then(res => {
							this.getAll()
							this.dialogVisible = false;
						})
					}
				}
			})

		},

		// 物业费通知
		confirmTenement(type) {
			this.$http.post("/api/ownerManage/approveFireControl", {
				type: type,
				key: "是",
			}).then(res => {
				if (type == 2) {
					this.fireSafetyVisible = true;
					this.propertyFeeVisible = false;
				} else {
					this.fireSafetyVisible = false;
				}

			})
		},

		// 
		personNumInput() {
			if (this.checkInFormData.roomNum * 2 < this.checkInFormData.personNum) {
				this.$message({
					message: "预约入住人数建议不要过多",
					showClose: true,
				});
			}
		},


		// 子组件向父组件传值
		changeVisible(e) {
			this.personInforVisible = e.personInforVisible;
			if (e.hasOwnProperty("isAlert")) {
				this.dialogVisible = true;
			}
		},

		// 下载文件
		downloadFile(val) {
			var file = {};
			if (val == 1) {
				file.name = "物业费说明.doc";
				file.url = "/home/boding/message/发业主收物业费说明.doc";
			} else {
				file.name = "消防安全责任书.doc";
				file.url = "/home/boding/message/消防安全责任书.doc";
			}
			downloadFile(file);
		},

		// 公告、通知的事件
		handleNotice() {
			this.getNoticeAndMessage();
		},

		// 去客房详情
		toCustomerRoom() {
			this.$router.push("/index/apartment/customerInformation/customerRoom")
		},
		// 去人才详情
		toTalentDetail() {
			this.$router.push("/index/apartment/personnelInformation");
		},
		// 马上入住
		toApplyCheckIn() {
			this.$router.push("/index/apartment/personnelInformation");
		},
		toEnerygyData(){
			this.$router.push("/index/engineering/energyManage/BAdata");
		}
	},
}
</script>

<style scoped="scoped">
.pre-check-in {
	position: relative;
	width: 100%;
	height: 100%;
}

.bg {
	width: 100%;
	height: 250px;
	position: absolute;
	left: 0;
	bottom: 10px;
	padding-right: 15px;
}

img {
	width: 100%;
	height: 100%;
}

.description {
	/* text-align: center; */
}

.description>p {
	color: #747474;
	margin: 15px 0;
}

.isShowPreCheckIn {
	/* text-align: center; */
	padding: 40px 0;
}

.isShowPreCheckIn p {
	margin: 15px 0;
}

.rightHousesNumber {
	color: #00a790;
	font-weight: bolder;
	font-size: 24px;
	margin: 0 10px;
}

.rightHousesNumber p {
	margin: 15px 0;
}

.preBtn {
	width: 300px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #B5AC8B;
	color: white;
	display: inline-block;
	border-radius: 5px;
	font-weight: bold;
}

.preCheckIn {}

.preCheckIn ul {
	padding-top: 60px;
	display: flex;
	justify-content: space-evenly;
}

.preCheckIn ul li {
	text-align: center;
}

.preCheckIn ul li p {
	margin: 10px 0;
}

.preCheckIn ul li p:nth-of-type(1) {
	font-weight: bolder;
	color: #454851;
}


.preCheckIn ul li img {
	width: 70px;
	height: 70px;
}

.number {
	font-weight: bolder;
	color: #00BFAF;
	font-size: 26px;
}

.modifyImg {
	position: absolute;
	top: 15px;
	right: 30px;
	display: block;
	width: 40px;
	height: 40px;
}



.zero div:nth-of-type(1) {
	display: flex;
	padding-top: 10px;
}

.zero div div:nth-of-type(1) {
	padding-top: 20px;
}

.zero div div:nth-of-type(2) {
	margin-top: 100px;
}

.zero img {
	width: 200px;
	height: 200px;
}


.tenement>p,
.fireSafety>p {
	margin: 15px 0;
	letter-spacing: 2px;
	line-height: 30px;
	font-size: 16px;
}

.fireSafety>p {
	text-indent: 2em;
}

.download {
	font-size: small;
	color: #666666;
	cursor: pointer;
}

.register {
	display: flex;
	justify-content: space-evenly;
	margin-top: 30px;
}



.top {
	height: 300px;
}

.bottom {
	display: flex;
	justify-content: space-evenly;
	padding-top: 60px;
}

.one,
.two,
.zero,
.three,
.four,
.five {
	width: 30%;
	position: relative;
	border: 1px solid #CCCCCC;
	padding: 20px;
}

#three,
#four,
#five {
	height: 300px;
}



.build {
	position: absolute;
	top: 0;
	display: block;
	width: 102%;
	height: 382px;
	line-height: 350px;
	text-align: center;
	background-color: #4a4a4a;
	color: white;
	z-index: 1000;
	opacity: 0.8;
	font-size: larger;
}

.detail {
	/* width: 45px;
		height: 45px; */
	position: absolute;
	top: 15px;
	right: 30px;
}

.more {
	position: absolute;
	bottom: 10px;
	right: 10px;
	cursor: pointer;
}

.circle {
	width: 6px;
	height: 6px;
	line-height: 6px;
	border-radius: 6px;
	display: inline-block;
	background-color: #CCCCCC;
	margin: 0 15px;
	position: relative;
	top: -1px;
}

.message {
	font-size: 15px;
	height: 25px;
	line-height: 25px;
	color: black;
	position: relative;
}

.message:hover {
	cursor: pointer;
	color: lightslategray;
}</style>
